import axios, { AxiosResponse } from 'axios';
import { API_URL } from '../config/envConfig';
import { AdPosition, ApiResponse } from '../types';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const adService = {
  // Tüm reklam pozisyonlarını getir
  getAllAdPositions: async (): Promise<AdPosition[]> => {
    const response: AxiosResponse<ApiResponse<AdPosition[]>> = await api.get('/ad-positions');
    return response.data.data;
  },
  
  // Belirli pozisyondaki reklamları getir
  getAdsByPosition: async (position: string): Promise<AdPosition[]> => {
    const response: AxiosResponse<ApiResponse<AdPosition[]>> = 
      await api.get(`/ad-positions/by-position/${position}`);
    return response.data.data;
  },
  
  // Belirli pozisyonda ve ekran boyutundaki reklamları getir
  getAdsByPositionAndScreenSize: async (position: string, screenSize: string): Promise<AdPosition[]> => {
    const response: AxiosResponse<ApiResponse<AdPosition[]>> = 
      await api.get(`/ad-positions/by-position/${position}/screen-size/${screenSize}`);
    return response.data.data;
  },
  
  // Kategori bazlı reklamları getir
  getAdsByCategoryAndPosition: async (categoryId: string, position: string): Promise<AdPosition[]> => {
    const response: AxiosResponse<ApiResponse<AdPosition[]>> =
      await api.get(`/ad-positions/by-category/${categoryId}/position/${position}`);
    return response.data.data;
  },
  
  // Kategori ve ekran boyutuna göre reklamları getir
  getAdsByCategoryPositionAndScreenSize: async (categoryId: string, position: string, screenSize: string): Promise<AdPosition[]> => {
    const response: AxiosResponse<ApiResponse<AdPosition[]>> =
      await api.get(`/ad-positions/by-category/${categoryId}/position/${position}/screen-size/${screenSize}`);
    return response.data.data;
  },
  
  // Haber bazlı reklamları getir
  getAdsByNewsIdAndPosition: async (newsId: string, position: string): Promise<AdPosition[]> => {
    const response: AxiosResponse<ApiResponse<AdPosition[]>> =
      await api.get(`/ad-positions/by-news/${newsId}/position/${position}`);
    return response.data.data;
  },
  
  // Haber ve ekran boyutuna göre reklamları getir
  getAdsByNewsIdPositionAndScreenSize: async (newsId: string, position: string, screenSize: string): Promise<AdPosition[]> => {
    const response: AxiosResponse<ApiResponse<AdPosition[]>> =
      await api.get(`/ad-positions/by-news/${newsId}/position/${position}/screen-size/${screenSize}`);
    return response.data.data;
  },
  
  // Akıllı reklam getirme - öncelikle haber bazlı, sonra kategori bazlı, son olarak genel reklamları getirir
  getSmartAds: async (
    position: string, 
    screenSize: string, 
    newsId?: string, 
    categoryId?: string
  ): Promise<AdPosition[]> => {
    try {
      // Create an object with the required parameters
      const params: Record<string, string> = {
        position,
        screenSize
      };
      
      // Only add newsId and categoryId if they're defined and not empty
      if (newsId) params.newsId = newsId;
      if (categoryId) params.categoryId = categoryId;
      
      // Log request parameters
      console.log('Smart ads request params:', params);
      
      // Make the API request with query parameters
      const response: AxiosResponse<ApiResponse<AdPosition[]>> = 
        await api.get('/ad-positions/smart', { params });
      
      // Debug log to check the response
      console.log('Smart ads response:', response.data);
      
      // Return empty array if data is null or undefined
      return response.data.data || [];
    } catch (error) {
      console.error('Error fetching smart ads:', error);
      if (axios.isAxiosError(error)) {
        console.error('Axios error details:', {
          status: error.response?.status,
          data: error.response?.data,
          message: error.message
        });
      }
      return [];
    }
  }
};

export default adService; 